<template>
  <template v-if="post">
    <template v-if="isDesktop && selectedComment?.content?.images?.length">
      <div class="gmf-post-modal-content gmf-context">
        <div class="gmf-post-modal-content-image">
          <div class="gmf-post-modal-skeleton-loader" v-if="!imageLoaded" :style="{ aspectRatio: selectedComment?.content?.images[selectedIndex].aspect }">
            <LoadingSpinner v-if="!imageLoaded" class="gmf-post-modal-skeleton-loading-spinner" />
          </div>
          <img v-show="imageLoaded" @load="updateDesktopHeight" ref="image" :src="selectedComment?.content?.images[selectedIndex].largeUrl || selectedComment?.content?.images[selectedIndex].url" />
        </div>
        <div class="gmf-post-modal-container gmf-scrollbar">
          <Post v-if="post" :post="post" @loadReplies="loadReplies" @update:votes="v => post.votes = v" :elements="{ images: false, uploads: true }" @selectedIndex="v => selectedIndex = v" @selectedComment="(comment, index) => { overrideComment = comment; selectedIndex = index; }" :inPostModal="true" />
          <template v-if="! hideSocialFeedButton">
            <a v-if="socialFeedUrl" class="gmf-btn gmf-primary" :href="socialFeedUrl">{{ t('post_modal.social_feed_btn') }}</a>
            <div v-else class="gmf-btn gmf-primary" @click="openSocialModal({ displayHeader: true })">{{ t('post_modal.social_feed_btn') }}</div>
          </template>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="gmf-post-card">
        <img class="gmf-post-card-image" ref="image" @load="calculateHeight" v-if="selectedComment?.content?.images?.length" :src="selectedComment?.content?.images[selectedIndex].largeUrl || selectedComment?.content?.images[selectedIndex].url">
        <div v-if="selectedComment?.content?.images?.length" class="gmf-post-card-header" ref="header">
        </div>
        <div class="gmf-post-card-scrollable" ref="scroll">
          <div :style="scrollMargin" ref="touchTarget" class="gmf-post-card-content-margin"></div>
          <div class="gmf-post-card-content" :style="scrollHeight">
            <Post v-if="post" :post="post" @loadReplies="loadReplies" @update:votes="v => post.votes = v" :elements="{ images: false, uploads: true }" @selectedIndex="v => selectedIndex = v" @selectedComment="(comment, index) => { overrideComment = comment; selectedIndex = index; }" :inPostModal="true" />
            <template v-if="! hideSocialFeedButton">
              <a v-if="socialFeedUrl" class="gmf-btn gmf-primary" :href="socialFeedUrl">{{ t('post_modal.social_feed_btn') }}</a>
              <div v-else class="gmf-btn gmf-primary" @click="openSocialModal({ displayHeader: true })">{{ t('post_modal.social_feed_btn') }}</div>
            </template>
          </div>
        </div>
      </div>
    </template>
  </template>
</template>

<style>
.gmf-modal-body.gmf-post-modal {
  padding: 0;
  max-width: 100%;
  max-height: 800px;
  height: 100%;
  overflow: hidden;
}
.gmf-post-card-container {
  height: 100%;
  background: var(--gmf-col-white);
}
.gmf-post-modal:has(.gmf-post-card) {
  background: transparent;
}

.gmf-post-modal-content {
  display: inline-grid;
  grid-template-columns: 1fr 500px;
  max-width: 100%;
  height: 100%;
  overflow: hidden;
}

.gmf-post-modal .gmf-card.gmf-sp {
  margin-bottom: 0;
  box-shadow: none;
  border: none !important;
  flex-grow: 1;
}

.gmf-post-modal-content-image {
  display: flex;
  background-color: black;
  overflow: hidden;
  height: 100%;
  max-width: 100%;
}
.gmf-post-modal-content-image img {
  max-width: 100%;
  height: 100%;
  object-fit: contain;
}
.gmf-post-modal-container {
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.gmf-post-modal-skeleton-loader {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, var(--gmf-col-gray) 0%, var(--gmf-col-white) 50%, var(--gmf-col-gray) 100%);
  position: relative;
}

.gmf-post-card-image {
  object-fit: contain;
  position: absolute;
  width: 100%;
  top: 0;
  max-height: 100%;
  background: black;
}

.gmf-post-card {
  width: 520px;
  max-width: 100%;
  height: 100%;
  
  display: flex;
  flex-direction: column;
  border-radius: var(--gmf-modal-rounding);
}

.gmf-post-card-header {
  height: 54px;  
  flex-shrink: 0;
}

.gmf-post-card-scrollable {
  flex-direction: column;
  flex-grow: 1;
  overflow-y: scroll;
  margin-top: 0px;
  height: calc(100% - 54px);
  border-radius: var(--gmf-modal-rounding);
  overscroll-behavior-y: none;
  display: flex;
  flex-direction: column;
}

.gmf-customer-card-container {
  display: flex;
  flex-grow: 1;
}

.gmf-post-card-content::-webkit-scrollbar,
.gmf-post-card-container::-webkit-scrollbar,
.gmf-post-card-scrollable::-webkit-scrollbar {
  display: none;
}

.gmf-post-card-content-margin {
  position: relative;
  z-index: 1;
  flex-shrink: 0;
}

.gmf-post-card-content {
  border-radius: var(--gmf-modal-rounding);
  background: var(--gmf-col-white);
  position: relative;
  z-index: 1;

  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.gmf-post-modal .gmf-card.gmf-sp .gmf-sp-action.gmf-text-small {
  padding-right: 32px;
}

@media (min-width: 1025px) {
  .gmf-modal-overlay:has(.gmf-post-modal) {
    padding: 60px;
  }
  .gmf-post-modal .gmf-card.gmf-sp {
    padding-top: var(--gmf-p-4);
  }
}

@media (max-width: 1024px) {
  .gmf-post-modal .gmf-card.gmf-sp {
    min-height: 600px;
  }
}

.gmf-post-card-content > .gmf-btn,
.gmf-post-modal-container > .gmf-btn {
  position: sticky;
  bottom: var(--gmf-p-4);
  margin: auto;
  margin-top: var(--gmf-p-5);
  z-index: 1;
}

.gmf-post-modal-skeleton-loading-spinner {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  margin: 0 auto;
}
</style>

<script>
import { defineAsyncComponent } from 'vue';

import LoadingSpinner from '@/components/LoadingSpinner';

const Post = defineAsyncComponent(() => {
  return import(/* webpackChunkName: "stage-2" */'@/widgets/SocialFeed/Post');
});

import state from '@/state';
import callApi from '@/utils/callApi';
import isSafari from '@/utils/isSafari';
import modalStack from '@/utils/modalStack';
import openSocialModal from '../SocialFeed/openSocialModal';

const trackingInfo = require('@/utils/tracking')();

const t = state.t;

function getIdMap(posts, idMap = {}) {
  for (const post of posts) {
    idMap[post.id] = post;
    if (post.replies) {
      getIdMap(post.replies, idMap);
    }
  }
  return idMap;
}

export default {
  name: 'SocialFeed',
  components: { Post, LoadingSpinner },
  inject: ['commentId', 'initialIndex'],
  data() {
    return {
      state,
      posts: [],
      commentIdToScrollTo: null,
      selectedIndex: this.initialIndex || 0,
      imageLoaded: false,
      selectedItem: {
        value: 'all',
        icon: null,
        filter: null,
      },

      include: 'author,votes,targets,linkedProducts,pollVotes',

      showSmallAvatar: false,
      expanded: false,
      marginTop: 0,
      navigationHeight: 0,
      inModal: false,

      order: 'created.desc',

      overrideComment: null,
    };
  },
  computed: {
    post () {
      return this.posts[0];
    },
    selectedComment () {
      return this.overrideComment || this.post;
    },
    isDesktop() {
      return window.innerWidth > 1000;
    },
    scrollMargin () {
      return {
        height: this.marginTop + 'px',
      };
    },
    scrollHeight() {
      let scroll = this.$refs.scroll;
      if (scroll) {
        let height = scroll.clientHeight;
        return { minHeight: height + 'px'};
      }
      return {};
    },
    boardMap() {
      const map = {};

      for (const board of this.boards) {
        map[board.id] = board;
      }

      return map;
    },
    selectedBoard() {
      if (this.selectedFilter && this.selectedFilter.board_id) {
        const board = this.boardMap[this.selectedFilter.board_id];
        if (board) {
          return board;
        }
      }
      return null;
    },
    query() {
      const q = {
        order: this.order,
        link: 'social_post',
      };
      if (this.selectedFilter) {
        Object.assign(q, this.selectedFilter);
      }
      return q;
    },
    idMap() {
      return getIdMap(this.posts || []);
    },
    socialFeedUrl() {
      return state.merchantConfig?.widgets?.urls?.socialFeed;
    },
    hideSocialFeedButton() {
      for (const modal of modalStack.stack) {
        if (modal.app.$options.name === "SocialFeed") {
          return true;
        }
      }
      return false;
    },
    translationsEnabled() {
      return state.merchantConfig?.widgets?.translations.mode !== 'translateNothing';
    }
  },
  async mounted() {
    await this.ensureCommentLoaded(this.commentId);
  },
  methods: {
    t,
    openSocialModal,
    updateDesktopHeight() {
      if (! isSafari || (trackingInfo.browser.name == "safari" && trackingInfo.browser.version >= "17.4.1")) {
        this.$el.parentElement.style.maxHeight = '';
      }

      this.imageLoaded = true;

      this.$nextTick(() => {
        let image = this.$refs.image;
        let height = image.clientWidth * image.naturalHeight / image.naturalWidth;
        this.$el.parentElement.style.maxHeight = Math.min(Math.max(height, 400), 900) + "px";
      });
    },
    calculateHeight() {
      let imgHeight = this.$refs.image?.clientHeight || 0;
      let headerHeight = this.$refs.header?.clientHeight || 0;
      
      const style = getComputedStyle(document.body);
      const borderRadius = parseInt(style.getPropertyValue('--gmf-rounding'), 10);
      
      // Adjust marginTop by subtracting the border radius
      if (imgHeight < this.$refs.scroll?.clientHeight) {
        this.marginTop = Math.max(imgHeight - headerHeight - borderRadius, 0);
      } else {
        this.marginTop = Math.max(imgHeight - headerHeight, 0);
      }

      this.$refs.scroll.focus();
      this.$nextTick(() => {
        if (this.marginTop >= this.$refs.scroll?.clientHeight) {
          this.$refs.scroll.scrollTop = this.marginTop - this.$refs.scroll?.clientHeight + 165;
        } else {
          this.$refs.scroll.scrollTop = 0;
        }
      })
    },
    async ensureCommentLoaded(id) {
      if (id in this.idMap) {
        return;
      }
      const query = new URLSearchParams({
        'id:root': id,
        translate: this.translationsEnabled,
        include: this.include,
        link: 'all'
      });
      const res = await callApi('GET', state.commentSearchEndpoint + `?${query.toString()}`);
      this.posts = (await res.json()).comments;
    },
    async loadReplies(id) {
      if (this.isLoading) {
        return;
      }
      const queryAtStart = JSON.stringify(this.query);
      this.isLoading = true;

      const root = this.idMap[id];
      if (!root) {
        console.error('Failed to load replies: Parent comment not in view');
        return;
      }

      try {
        let skip = root.replies.length;
        if (skip && root.replies[0].replyCount === null) {
          skip = 0; // need to reload the replies
        }
        const query = Object.assign({}, this.query, {
          'skip': skip,
          'take': 3,
          'reply_count': 5,
          'reply_depth': 2,
          'root': root.id,
          'translate': this.translationsEnabled,
          'include': this.include,
        });
        const res = await callApi('GET', state.commentSearchEndpoint + '?' + new URLSearchParams(query).toString());

        if (queryAtStart != JSON.stringify(this.query)) {
          // Query has changed, throw result away
          this.isLoading = false;
          return;
        }

        const data = await res.json();

        for (const c of data.comments) {
          if (!(c.id in this.idMap)) {
            root.replies.push(c);
          } else {
            // Update existing comment, because it might have been a partial load
            Object.assign(this.idMap[c.id], c);
          }
        }
      } catch (e) {
        console.error('Reply load failed', e);
      }
      this.isLoading = false;
    },
  },
};
</script>
